import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Sparkles, Users, ArrowRight } from 'lucide-react';

const VIDEO_ID = "11iD9BD4MHQQ3vg8x4XDBpmtCzyYo542b";
const IG_REEL = "DT2nl-TjHvY";

const Workshops = () => {
  return (
    <div className="workshops-page" data-testid="workshops-page">
      <header className="header-nav">
        <div className="header-content">
          <Link to="/" data-testid="ws-logo-link">
            <img src="/brand/logo.png" alt="Momshiach" className="logo-img" />
          </Link>
          <nav className="desktop-nav">
            <Link to="/" className="nav-link" data-testid="ws-nav-home">Home</Link>
            <Link to="/carebnb" className="nav-link">CareBnB</Link>
            <Link to="/health-coaching" className="nav-link">Health Coaching</Link>
            <Link to="/resources" className="nav-link">Resources</Link>
          </nav>
          <div className="nav-actions">
            <a href="https://wa.me/972529326458" target="_blank" rel="noopener noreferrer" className="btn-secondary btn-contact">
              <Phone size={16} />
              <span>Contact</span>
            </a>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="workshops-hero">
        <div className="container">
          <div className="workshops-eyebrow">
            <Sparkles size={14} />
            <span>Live · Hands-on · In Israel & Online</span>
          </div>
          <p className="hero-tagline" data-testid="workshops-tagline">Your Personal Redemption</p>
          <h1 className="heading-hero" data-testid="workshops-hero-title">Momshiach Workshops</h1>
          <p className="body-large workshops-sub">
            Live, hands-on gatherings for women learning how to nourish themselves — in Israel and online. Come to my kitchen, or bring me to yours.
          </p>
        </div>
      </section>

      {/* Featured video (Drive embed) */}
      <section className="workshops-video-section">
        <div className="container container-narrow">
          <div className="section-header">
            <h2 className="heading-1">Watch what a workshop feels like</h2>
            <p className="body-large text-secondary">This is what happens when women gather around real food, real conversation, and real color.</p>
          </div>

          <div className="video-embed">
            <iframe
              src={`https://drive.google.com/file/d/${VIDEO_ID}/preview`}
              allow="autoplay"
              allowFullScreen
              title="Momshiach Workshops"
              data-testid="workshops-drive-video"
            />
          </div>
        </div>
      </section>

      {/* Instagram reel */}
      <section className="workshops-video-section bg-section">
        <div className="container container-narrow">
          <div className="section-header">
            <h2 className="heading-1">A taste of the kitchen 🥑</h2>
            <p className="body-large text-secondary">A real cooking workshop, straight from my kitchen.</p>
          </div>

          <div className="ig-embed-wrap">
            <iframe
              src={`https://www.instagram.com/reel/${IG_REEL}/embed`}
              scrolling="no"
              allowFullScreen
              title="Cooking workshop reel"
              data-testid="workshops-ig-reel"
              className="ig-embed"
            />
          </div>
        </div>
      </section>

      {/* Inquire CTA */}
      <section className="workshops-inquire">
        <div className="container container-narrow">
          <div className="inquire-card">
            <Users size={40} color="var(--brand-gold)" />
            <h2 className="heading-1">Ready to book a workshop?</h2>
            <p className="body-large">
              Every workshop is designed for your group — a shul kiddush club, a bat-mitzvah, a midrasha, a corporate team, a Yom Iyun. Reach out and I'll build one that fits.
            </p>
            <div className="inquire-ctas">
              <a
                href="https://wa.me/972529326458?text=Hi%20Chanah%2C%20I'd%20love%20to%20book%20a%20Momshiach%20Workshop"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary btn-lg"
                data-testid="workshops-whatsapp-cta"
              >
                <Phone size={18} />
                <span>WhatsApp Chanah</span>
                <ArrowRight size={16} />
              </a>
              <a
                href="mailto:chanahrothberg@gmail.com?subject=Workshop%20Inquiry"
                className="btn-secondary btn-lg"
                data-testid="workshops-email-cta"
              >
                <Mail size={18} />
                <span>Email Chanah</span>
              </a>
            </div>
            <div className="ig-follow" style={{ marginTop: '2rem' }}>
              <a
                href="https://www.instagram.com/chefrawraw/"
                target="_blank"
                rel="noopener noreferrer"
                className="ig-follow-link"
                data-testid="workshops-ig-follow"
              >
                <span className="ig-emoji">📸</span>
                <span>Follow <strong>@chefrawraw</strong> for daily kitchen inspiration</span>
                <ArrowRight size={14} />
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-bottom">
            <p className="caption">© 2025 Momshiach · Workshops</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Workshops;
